import {StyledToggleGroupTeamItem, StyledToggleGroupTeamRoot} from '@/components/commons/toggle-group-list-type/style'
import {TKey, useTranslation} from '@/translations/i18n'
import {ObjectKeys} from '@/utilities/helpers'

export const ToggleGroupListType = <T extends string>({
    listType,
    setListType,
    radioList
}: {
    listType: T
    setListType: (listType: T) => void
    radioList: Record<T, {label: TKey; value: T}>
}) => {
    const {t} = useTranslation()

    return (
        <>
            <StyledToggleGroupTeamRoot
                type="single"
                value={listType}
                onValueChange={(value: T) => value && setListType(value)}
            >
                {ObjectKeys(radioList).map(key => (
                    <StyledToggleGroupTeamItem
                        key={key}
                        value={radioList[key].value}
                        aria-label={t(radioList[key].label)}
                    >
                        {t(radioList[key].label)}
                    </StyledToggleGroupTeamItem>
                ))}
            </StyledToggleGroupTeamRoot>
        </>
    )
}
